import { normalizeArray } from "./arrays";

// External commerce sources (commercetools / SFCC) return absolute image URLs
// already; JCR returns paths relative to the Magnolia host that need the base
// prefix. Detect absolute and pass through unchanged.
const isAbsoluteUrl = (link) => typeof link === "string" && /^(https?:)?\/\//i.test(link);
const composeImageLink = (link) => (isAbsoluteUrl(link) ? link : process.env.REACT_APP_MAGNOLIA_BASE_URL + link);

export const getImagesLink = (imageNode, renditions) => {
    const renditionsArr = normalizeArray(renditions);
    const links = {};

    for (const rendition of renditionsArr) {
        const link = getImageLink(imageNode, rendition);

        if (link) links[rendition] = link;
    }

    return links;
};

// Multi-DAM structure (SERVDEMO-707): image/logo properties may be subnodes like
// {field: "dam", image: <resolved asset>} instead of a directly resolved asset. Unwrap to
// the inner asset; flat nodes (foundation modules without the migration) pass through.
const resolveAssetNode = (imageNode) => {
    if (!imageNode || typeof imageNode !== "object" || !imageNode.field) return imageNode;
    if (imageNode.field === "dam") return imageNode.image;
    if (imageNode.field === "cloudinary") return imageNode.cloudinaryImage;
    return imageNode;
};

export const getImageLink = (imageNode, rendition = null) => {
    imageNode = resolveAssetNode(imageNode);
    if (!imageNode) return null;
    // A cloudinary reference (or an external source) may be a plain URL string.
    if (typeof imageNode === "string") return composeImageLink(imageNode);
    if (!rendition) return composeImageLink(imageNode["@link"]);

    if (!imageNode.renditions || !imageNode.renditions[rendition]) return null;

    return composeImageLink(imageNode.renditions[rendition].link);
};

// Caption as maintained in the Assets app; external/string images carry none.
export const getImageCaption = (imageNode) => {
    imageNode = resolveAssetNode(imageNode);
    if (!imageNode || typeof imageNode === "string") return "";
    return (imageNode.metadata || {}).caption || "";
};

export const getImageAltText = (imageNode) => {
    imageNode = resolveAssetNode(imageNode);
    if (!imageNode || typeof imageNode === "string") return "";
    // JCR images carry a `metadata` sub-object with title/caption; external
    // commerce images don't — fall back to the image's @name or an empty string
    // so the React img tag still renders.
    const metadata = imageNode.metadata || {};
    return metadata.title || metadata.caption || imageNode["@name"] || "";
};
